import * as ko from "knockout";
import BaoDialogViewModel from "../../factories/bao-dialog";
import { TenantSwitcher } from "../../factories/tenant-switcher/tenant-switcher";
import Bao from "../../services/bao-service";
import RequestResetPassword from "../../view-models/bao-dialog/request-reset-password";
import { PasswordChanger } from "./../../factories/password-changer/password-changer";
import template from "./login-page2.html";

export class LoginPage {

	public get CaptionNoConnection() {
		switch (this.LanguageSymbol()) {
			case "de-DE":
				return "Keine Verbindung zum Server";
			default:
				return "No connection to the server";
		}
	}

	public NewDesign = ko.observable(false);
	public IsLoading = ko.observable(false);
	public LanguageSymbol = ko.observable("");
	public Password = ko.observable("");
	public Username = ko.observable("");
	public CurrentVersion = ko.observable("7.0.0");
	public CaptionUsername = ko.observable("Username");
	public CaptionPassword = ko.observable("Password");
	public CaptionLanguage = ko.observable("Language");
	public CaptionLogin = ko.observable("");
	public CaptionAutoLogin = ko.observable("");
	public CaptionRequestPassword = ko.observable("forgot password?");
	public CaptionEnableRegisterUser = ko.observable("");
	public CaptionADAuth = ko.observable("");
	public CaptionOk = ko.observable("Ok");
	public LanguageList = ko.observableArray<{ Caption: string, Symbol: string }>([]);
	public MandatorActive = ko.observable(false);
	public ADAuth = ko.observable(true);
	public ADAuthEnabled = ko.observable(false);
	public CookiesEnabled = ko.observable(false);
	public EnableRegisterUser = ko.observable(false);
	public EnableForgotPassword = ko.observable(false);
	public FormVisible = ko.observable(true);

	public ADAuthActive = ko.pureComputed(() => {
		return this.ADAuth() == true && this.ADAuthEnabled() == true;
	});
	public Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName());

	private subscriptions: KnockoutSubscription[] = [];
	constructor(private callback: () => void) {

		this.subscriptions.push(this.ADAuthActive.subscribe((newValue) => {
			this.Username("");
			if (newValue == true) {
				this.GetADName();
				this.Password("");
			}
		}));

		this.subscriptions.push(this.Password.subscribe((newValue) => {
			if (this.ADAuthActive() == true && newValue != "") {
				this.Password("");
			}
		}));

		this.Dialog.Buttons([new BaoDialogViewModel.ButtonFactory(this.Dialog, this.CaptionOk)]);
		this.Dialog.Width("400px");
		this.Dialog.VerticalMode("middle");

		let captionDeferred;
		this.subscriptions.push(this.LanguageSymbol.subscribe(() => {
			this.IsLoading(true);
			if (captionDeferred != null && captionDeferred.abort != undefined) {
				captionDeferred.abort();
			}
			captionDeferred = Bao.Session.GetCaptions("Login", this.LanguageSymbol()).then((captions) => {
				this.CaptionUsername(captions.lblUsername);
				this.CaptionPassword(captions.lblPassword);
				this.CaptionLanguage(captions.lblLanguage);
				this.CaptionAutoLogin(captions.lblAutoLogin);
				this.CaptionRequestPassword(captions.lblRequestPassword);
				this.CaptionEnableRegisterUser(captions.lblRegisterUser);
				this.CaptionLogin(captions.btnLogin);
				this.CaptionADAuth(captions.lblADAuth);
				this.CaptionOk(captions.btnOk);
				this.IsLoading(false);
			});
		}));
	}

	public RequestResetPassword() {
		const d = new RequestResetPassword(this.LanguageSymbol(), this.Username());
	}

	public SingleSignOn(force?) {
		const def = $.Deferred();
		if (force == true || this.getParam("mode") != "logout") {
			this.IsLoading(true);
			const languageSymbol = "";
			if (force == true) {
				const languageSymbol = this.LanguageSymbol();
			}
			return Bao.post("Login/SingleSignOn", JSON.stringify({
				languageSymbol: languageSymbol
			}), function (result) {
				if (result === true) {
					this.SelectClient(window.absolutePath);
				}
			}).always(function () {
				this.IsLoading(false);
				def.resolve();
			});
		} else {
			def.resolve();
		}
		return def.promise();
	}

	public Login() {
		if (this.ADAuthActive()) {
			this.SingleSignOn(true);
		} else {
			this.IsLoading(true);
			Bao.post("Login/Login", JSON.stringify({
				loginModel: ko.map.toJS(this)
			}), (value) => {
				if (value.Result == true) {
					this.SelectTenant();
				} else {
					this.IsLoading(false);
					if (value.Id == "UserMustChangePassword") {
						this.ChangePassword();
					} else {
						this.Password("");
						this.Dialog.Template(value.Message);
						this.Dialog.Open();
						this.Dialog.Closed = () => {
							this.UserFocus();
						};
					}
				}
			}).fail(() => {
				this.IsLoading(false);
				this.Dialog.Template(this.CaptionNoConnection);
				this.Dialog.Open();
				this.Dialog.Closed = () => {
					this.UserFocus();
				};
			});
		}
	}

	public SelectTenant() {
		this.IsLoading(false);
		if (this.MandatorActive()) {
			const tenantSwitcher = new TenantSwitcher();
			tenantSwitcher.Open().then((result) => {
				if (result) {
					this.callback();
				} else {
					this.UserFocus();
				}
			});
		} else {
			this.callback();
		}
	}

	public UserFocus() {

	}

	public dispose() {
		this.IsLoading(false);
	}

	public getParam(variable) {
		const query = window.location.search.substring(1);
		const vars = query.split("&");
		for (let i = 0; i < vars.length; i++) {
			const pair = vars[i].split("=");
			if (pair[0] == variable) {
				return pair[1];
			}
		}
		return false;
	}
	public init() {
		this.IsLoading(true);
		return Bao.post("Login/GetLoginModel", (result) => {
			this.IsLoading(false);
			ko.map.fromJS(result, this);
		}).fail(() => {
			this.IsLoading(false);
		});
	}

	public loaded() {
		this.SingleSignOn();
	}

	private ChangePassword() {
		if (typeof this.LanguageSymbol() === "undefined") {
			this.LanguageSymbol(Bao.Session.Language.Symbol());
		}
		const passwordChanger = new PasswordChanger();
		passwordChanger.LanguageSymbol(this.LanguageSymbol());
		passwordChanger.Username(this.Username());
		passwordChanger.OldPassword(this.Password());
		passwordChanger.Open().then((result) => {
			if (result) {
				this.SelectTenant();
			} else {
				this.UserFocus();
			}
		});
	}

	private GetADName() {
		Bao.post("Login/GetADName", (value) => {
			this.Username(value);
		});
	}
}

export default {
	viewModel: {
		createViewModel: function (params, componentInfo) {
			const e = componentInfo.element;
			let vm: LoginPage = null;
			ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
				if (vm != null) {
					vm.dispose();
				}
			});
			vm = new LoginPage(params.callback);
			vm.init();
			return vm;
		}
	},
	template: template
};
